"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowNextArrow = void 0;
var _constants = require("../constants");
const shouldShowNextArrow = ({
  lastSlideVisible,
  slidesCount,
  currentSlide = 0,
  slider
}) => {
  const {
    loop,
    slides
  } = slider ?? {};
  const isAutoPerView = typeof slides === 'object' && slides?.perView === 'auto';
  const perView = typeof slides === 'object' && typeof slides?.perView === 'number' ? slides.perView : _constants.SLIDES_PER_VIEW_DEFAULT_VALUE;
  if (loop === undefined || loop === false) {
    if (isAutoPerView) {
      return !lastSlideVisible;
    }
    return currentSlide !== slidesCount - perView;
  }
  if (loop === true) {
    return true;
  }
  return loop.max === undefined || currentSlide < loop.max - perView + 1;
};
exports.shouldShowNextArrow = shouldShowNextArrow;
//# sourceMappingURL=shouldShowNextArrow.js.map